import { IataAirlineErrors } from "../objects/iataAirlineErrors";
import { IataAirlineFormType } from "../objects/iataAirlineForm";
import { Column } from "../objects/column";
import { IataAirlineListConfiguration } from "../objects/iataAirlineListConfiguration";
import { IataAirlineListCriteria, IataAirlineListFiltersCriteria } from "../objects/iataAirlineListCriteria";

export const IATA_AIRLINE_MODULE = 'IATA_AIRLINE';

export const EMPTY_IATA_AIRLINE_FILTERS: IataAirlineListFiltersCriteria = {
    owner_filter: 'TO',
};

export const EMPTY_IATA_AIRLINE_LIST_CRITERIA: IataAirlineListCriteria = {
    limit: 10,
    page: 0,
    search: '',
    order_by: '',
    order: 'asc',
    filters: EMPTY_IATA_AIRLINE_FILTERS,
};

export const DEFAULT_COLUMN: Column[] = [{
    label: 'airline-code',
    field_name: 'AIRLINE_CODE',
    checked: true,
    order_by: 'airline_code',
    fixed_width: true,
    last_updated: false
}, {
    label: 'commercial-name',
    field_name: 'COMMERCIAL_NAME',
    checked: true,
    order_by: 'commercial_name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'alliance',
    field_name: 'ALLIANCE',
    checked: true,
    order_by: 'alliance',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_IATA_AIRLINE_LIST_CONFIGURATION: IataAirlineListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const EMPTY_IATA_AIRLINE_FORM: IataAirlineFormType = {
    airline_code: '',
    commercial_name: '',
    alliance: null,
};

export const EMPTY_IATA_AIRLINE_ERRORS: IataAirlineErrors = {
    airline_code_error: '',
    commercial_name_error: '',
};
